import { Component, OnInit } from '@angular/core';
import { RolesAndPermissionsService } from '../../../../services/roles-and-permissions.service';
import { InvoiceSaleService } from '../../inventory/sales/invoice-sale/invoice-sale.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ResponseObject } from 'src/app/models/response-object.model';
import { PositionUserResponse, User, PositionUserRequest, UserRequestRole } from 'src/app/models/user.model';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CashierService } from 'src/app/services/cashier.service';

@Component({
  selector: 'app-user-role',
  templateUrl: './user-role.component.html',
  styleUrls: ['./user-role.component.scss']
})
export class UserRoleComponent implements OnInit {

  warehouses = [];
  areas = [];
  departments = [];
  area: number;
  department: number;
  positions = [];
  positionUser: number;
  users: User[] = [];
  filterUsers: User[] = [];
  email = "";
  userSelected: any;
  positionSelected: any;
  actualPosition = null;
  isEdit = false;
  newUser: UserRequestRole = new UserRequestRole();
  loading = false;
  errorMessageEmail = "";
  creating = false;
  cashiers = [];
  currentCompany = null;
  deleting: { [key: number]: boolean } = {};
  wait = null;

  constructor(
    private roleService: RolesAndPermissionsService,
    private invoiceService: InvoiceSaleService,
    private authService: AuthenticationService,
    private toastService: ToastrService,
    private router: Router,
    private cashierService: CashierService
  ) {
    this.currentCompany = parseInt(authService.getCurrentCompanyId());
  }

  showAndHide(show) {
    this.creating = show;
    this.newUser = new UserRequestRole();
  }

  resetDeletingDiv() {
    this.wait = null;
  }

  showDeleteQuestion(user) {
    this.wait = user;
  }

  deleteUser(user) {
    if (this.deleting[user.id]) {
      return;
    }
    this.wait = null;
    this.deleting[user.id] = true;
    this.roleService.deleteUserPosition(user.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se eliminó correctamente al usuario");
        this.deleting[user.id] = false;
        this.getUsers();
        this.showAndHide(false);
      },
      error: (error: HttpErrorResponse) => {
        this.deleting[user.id] = false;
        this.toastService.error("Error al eliminar al usuario");
      }
    })
  }

  checkAndSaveUser() {
    this.loading = true;
    this.errorMessageEmail = "";
    this.roleService.checkEmail(this.newUser.email, this.currentCompany).subscribe({
      next: (response: ResponseObject) => {
        var permissions = { companies: [], email: '' };
        permissions.email = this.newUser.email;
        var newCompany = { id: parseInt(this.authService.getCurrentCompanyId()), roles: [] };
        newCompany.roles.push(2000);
        permissions.companies.push(newCompany);
        this.roleService.saveUserOnOldTable(permissions).subscribe({
          next: (response: ResponseObject) => {
            this.toastService.success("Se agregó correctamente al usuario");
            this.loading = false;
            this.getUsers();
            this.showAndHide(false);
          },
          error: (error: HttpErrorResponse) => {
            this.loading = false;
            this.toastService.error(error.error.message);
          }
        })
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.errorMessageEmail = error.error.message;
      }
    })
  }

  filter() {
    if (this.email != '') {
      this.filterUsers = this.users.filter((user) => {
        return user.email.includes(this.email)
      })
      if (this.filterUsers.length == 1) {
        this.userSelected = this.filterUsers[0];
      } else {
        this.userSelected = null;
      }
    } else {
      this.filterUsers = this.users;
      this.userSelected = null;
    }
  }

  selectedUser(user: any) {
    this.userSelected = user;
    this.roleService.getUserPosition(this.userSelected.id).subscribe({
      next: (response: ResponseObject) => {
        var userPosition = response.data as PositionUserResponse[];
        if (userPosition.length > 0) {
          userPosition.forEach((userPosition) => {
            var findOut = this.warehouses.find((w) => {
              return w.warehouse.id == userPosition.warehouse
            });
            if (findOut)
              findOut.selected = true;
          });
          userPosition.forEach((userPosition) => {
            var findOut = this.cashiers.find((c) => {
              return c.id == userPosition.cash
            });
            if (findOut)
              findOut.selected = true;
          });
          this.roleService.getPositions().subscribe({
            next: (response: ResponseObject) => {
              var tempPosition = response.data;
              for (let i = 0; i < tempPosition.length; i++) {
                const element = tempPosition[i];
                if (element.id == userPosition[0].positionRoleId) {
                  this.actualPosition = element;
                  this.positionUser = element.id;
                  break;
                }
              }
            }
          });
          this.isEdit = true;
        } else {
          this.isEdit = false;
          this.actualPosition = "";
        }
      },
      error: (error: any) => {
        this.isEdit = false;
        this.actualPosition = "";
      }
    })
  }

  ngOnInit(): void {
    this.getUsers();
    this.invoiceService.getWarehouses().subscribe({
      next: (response: ResponseObject) => {
        response.data.forEach(element => {
          this.warehouses.push({ warehouse: element, selected: false });
        });
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las bodegas, por favor recarga la página");
      }
    })

    this.roleService.getAreas().subscribe({
      next: (response: ResponseObject) => {
        this.areas = response.data;
        this.area = this.areas[0].id;
        this.getDepartmentsByArea(this.area);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las areas, por favor recarga la página");
      }
    })

    this.cashierService.getCashiersByClue('').subscribe(
      {
        next: (response: ResponseObject) => {
          this.cashiers = response.data;
          this.cashiers.forEach((c) => {
            c['selected'] = false;
          })
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener las areas, por favor recarga la página");
        }
      }
    )
  }

  getUsers() {
    this.roleService.getUsers(parseInt(this.authService.getCurrentCompanyId())).subscribe({
      next: (response: ResponseObject) => {
        this.users = response.data as User[];
        
        this.users = this.users.filter(u =>
          !u.email.toLowerCase().includes('@servicios.gt') && !u.email.toLowerCase().includes('@impulsocomercial.gt')
        );
        
        this.users.forEach((user) => {
          user['selected'] = false;
          user['showing'] = true;
        });

        this.filterUsers = this.users;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error('Problema al obtener los usuarios de la base de datos');
      }
    })
  }

  changeArea() {
    this.getDepartmentsByArea(this.area);
  }

  getDepartmentsByArea(idArea: number) {
    this.roleService.getDepartmentsByArea(idArea).subscribe({
      next: (response: ResponseObject) => {
        this.departments = response.data;
        this.department = this.departments[0].id;
        this.getDepartmentsPositions(this.department);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener los departamentos del área seleccionada, intenta de nuevo");
      }
    })
  }

  getDepartmentsPositions(idDepartment: number) {
    this.roleService.getDepartmentPositions(idDepartment).subscribe({
      next: (response: ResponseObject) => {
        this.positions = response.data;
        this.positions.forEach((position) => {
          if (position.superior) {
            position['superiorName'] = "--";
            for (let i = 0; i < this.positions.length; i++) {
              const element = this.positions[i];
              if (element.id == position.superior) {
                position['superiorName'] = element.name;
                break;
              }
            }
          }
        })
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las posiciones del departamento seleccionado, intenta de nuevo");
      }
    })
  }

  changeDepartment() {
    this.getDepartmentsPositions(this.department);
  }

  saveUser() {
    var userPositionRequest = new PositionUserRequest();
    userPositionRequest.user = this.userSelected.id;
    userPositionRequest.position = this.positionUser;
    this.warehouses.forEach((w) => {
      if (w.selected) {
        userPositionRequest.warehousesList.push({ warehouse: w.warehouse.id });
      }
    });
    this.cashiers.forEach((c) => {
      if (c.selected) {
        userPositionRequest.cashList.push({ cash: c.id });
      }
    });
    if (this.isEdit) {
      this.roleService.editUserPosition(userPositionRequest).subscribe(
        {
          next: (response: any) => {
            this.toastService.success("Editada la posicion del usuario " + this.userSelected.email);
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['configuration/user-role']);
            })
          },
          error: (error: any) => {
            this.toastService.error("Error al editar la posicion del usuario " + this.userSelected.email);
          }
        }
      );
    } else {
      this.roleService.saveUserPosition(userPositionRequest).subscribe(
        {
          next: (response: any) => {
            this.toastService.success("Guardada la posicion del usuario " + this.userSelected.email);
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['configuration/user-role']);
            })
          },
          error: (error: any) => {
            this.toastService.error("Error al guardar la posicion del usuario " + this.userSelected.email);
          }
        }
      );
    }
  }
}
